<template>
  <div
    :ref="'tooltip-' + tooltipName"
    :class="tooltipClass">
    <div
      class="f-tooltip-text"
      :style="currentTooltipStyle">
      <p class="my-0 inline-block">{{ tooltipText }}</p>
    </div>
  </div>
</template>
<script>

export default {
  name: 'f-tooltip',
  props: {
    parentElementClass: {
      type: String,
      required: true
    },
    tooltipName: {
      type: String,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    }
  },
  computed: {
    tooltipClass () {
      let classes = ['f-tooltip'];
      classes.push(this.tooltipName);

      return classes.join(' ');
    }
  },
  data() {
    return {
      currentTooltipStyle: null,
      resizeObserver: null,
      tooltipTextMaxWidth: ''
    }
  },
  mounted() {
    this.observeHeight();
    this.setTooltipTextWidth();
  },
  methods: {
    observeHeight () {
      if (this.$refs['tooltip-' + this.tooltipName]) {
        this.currentTooltipText = this.$refs['tooltip-' + this.tooltipName].querySelector('.f-tooltip-text');
      } else {
        return;
      }

      let parent = this.currentTooltipText.closest('.' + this.parentElementClass);
      this.resizeObserver = new ResizeObserver(() => {
        this.setTooltipTextWidth();
      });

      this.resizeObserver.observe(parent);
    },
    setTooltipTextWidth () {
      let currentTooltip = this.$refs['tooltip-' + this.tooltipName];
      let currentTooltipText = this.$refs['tooltip-' + this.tooltipName].querySelector('.f-tooltip-text p');
      let parent = currentTooltip.closest('.' + this.parentElementClass);
      let tooltipBoundingBox = currentTooltip.getBoundingClientRect();
      let parentBoundingBox = parent.getBoundingClientRect();
      let maxTooltipTextWidth = Math.floor(parentBoundingBox.width - (tooltipBoundingBox.x - parentBoundingBox.x) - 15);

      if (maxTooltipTextWidth < 120) {
        maxTooltipTextWidth = Math.floor(tooltipBoundingBox.x);
        if (currentTooltipText.offsetHeight < 20) {
          maxTooltipTextWidth = Math.min(maxTooltipTextWidth, currentTooltipText.offsetWidth + 30);
        }

        this.currentTooltipStyle = `width: ${maxTooltipTextWidth}px; left: unset; right: 0;`;
        return;
      }

      if (currentTooltipText.offsetHeight < 20) {
        maxTooltipTextWidth = Math.min(maxTooltipTextWidth, currentTooltipText.offsetWidth + 30);
      }

      this.currentTooltipStyle = `width: ${maxTooltipTextWidth}px`;
    }
  },
  beforeDestroy () {
    this.resizeObserver.disconnect()
  }
}
</script>
